import { getOrgByGroup } from 'reduxpath/ducks/Organisation'

import Home from 'units/Client'
import List from 'units/Client/units/List'

const populate = (store) => {
  store.dispatch(
    getOrgByGroup('client'),
  )
}

export default {
  activity: {
    populate,
  },
  components: {
    Home,
    List,
  },
}
